<template>
  <div>
    <ServicesCard v-model="buttons" @click="click"></ServicesCard>

    <RHorRODialog v-model="showRHorRODialog" :query="query" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ServicesCard from "@/components/shared/cards/ServicesCard.vue";
import RHorRODialog from "@/components/aberration/new/children/RHorRODialog.vue";
import { ButtonGroupObject } from "@/types/interface";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "ProjectShortcuts",
  props: {
    houseIsActive: {
      type: Boolean,
    },
    hasBarrack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showRHorRODialog: false,
      query: undefined,
    };
  },
  methods: {
    click(item) {
      if (item.emit === "openRHorRODialog") {
        this.query = undefined;
        this.showRHorRODialog = true;
        this.query = item.query;
      } else if (item.emit) {
        this.$emit(item.emit, item);
      }
    },
  },
  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
    }),
    buttons(): Array<ButtonGroupObject> {
      const query = {
        projectId: this.$route.params.id,
        houseId: this.$route.params.houseId,
      };

      var buttons = [
        {
          title: "Nytt Avvik",
          icon: "mdi-progress-wrench",
          to: "Aberration",
          query: query,
        },
        {
          title: "HMS-rapport",
          icon: "mdi-alert-octagram-outline",
          // to: "RUH",
          query: query,
          emit: "openRHorRODialog",
        },

        {
          title: "Kontakter",
          icon: "mdi-account-group-outline",
          to: "ProjectContacts",
        },
        {
          title: "HMS Plan",
          icon: "mdi-account-hard-hat",
          to: "ProjectHms",
        },
        {
          title: "Møtereferater",
          icon: "mdi-script-text-outline",
          to: "ProjectMinutes",
        },
        {
          title: "Dokumenthotell",
          icon: "mdi-file-document-multiple-outline",
          to: "ProjectDocuments",
        },
      ] as Array<ButtonGroupObject>;

      if (this.houseIsActive) {
        buttons.push({
          title: "Byggtegninger",
          icon: "mdi-floor-plan",
          to: "BuildingBlueprintsView",
        });
        buttons.push({
          title: "Tilvalgsliste",
          icon: "mdi-package-variant",
          emit: "optionsDownload",
        });
        buttons.push({
          title: "Fargevalg",
          icon: "mdi-format-paint",
          emit: "colorDownload",
        });
        if (this.isTrysilhus) {
          buttons.push({
            title: "Bestillinger",
            icon: "mdi-truck-delivery-outline",
            to: "OrdersView",
          });
        }
      } else {
        buttons.push({
          title: "Prosjekttegninger",
          icon: "mdi-floor-plan",
          to: "ProjectBlueprints",
        });
        if (this.isTrysilhus && this.hasBarrack) {
          buttons.push({
            title: "Booking",
            icon: "mdi-calendar-range ",
            to: "ProjectBookings",
          });
        }
      }

      return buttons;
    },
  },
  components: {
    ServicesCard,
    RHorRODialog,
  },
});
</script>
